import * as jQuery from '../node_modules/jquery';
(<any>window).$ = (<any>window).jQuery = jQuery;

import Swiper, { Navigation, Pagination, Autoplay, EffectFade, FreeMode } from '../node_modules/swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, FreeMode]);

declare var require: any
var mixitup = require('../node_modules/mixitup/dist/mixitup.min.js');

var mixitupMultifilter = require('../js/Workpage/mixitup-multifilter.min.js');
mixitup.use(mixitupMultifilter);


//swiper
//========================================================
var onOff = true;

const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    grabCursor: true,

    slidesPerView: 4,
    spaceBetween: 30,

    speed: 2000,

    autoplay: {
        delay: 400,
        disableOnInteraction: false,
    },
    
    enabled: onOff,
      
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  var swiperPage = document.getElementsByClassName("swiper").length;

  if(window.matchMedia("(max-width: 720px)").matches && document.getElementsByClassName("swiper").length){
    if(swiperPage > 0){
      swiper.destroy();  
    }
    
  }
  //========================================================


//Hamburger
//========================================================
const navToggle = document.getElementById('nav-toggle');
const navList = document.querySelector('.primary-navigation-list') as HTMLElement;
const body = document.querySelector('body') as HTMLElement;
let arrow = document.querySelectorAll('.arrow');
let parentNav = document.querySelectorAll('.parentNav');
//const dropdown = document.querySelector('.dropdown-list') as HTMLElement;

navToggle.addEventListener('click', function () {
  navToggle.classList.toggle('open');
  navList.classList.toggle('open');
  body.classList.toggle('overflow');
});

Array.from(arrow).forEach((el) => {
  el.addEventListener('click', function (e) {
    const openArrow = e.target as HTMLElement;
    const dropdown = openArrow.parentElement.nextSibling.nextSibling as HTMLElement;
    openArrow.classList.toggle('open');
    dropdown.classList.toggle('open');
  });
})

Array.from(parentNav).forEach((el) => {
  el.addEventListener('click', function (e) {
    const parentNode = e.target as HTMLElement;
    const openArrow = parentNode.nextSibling.nextSibling as HTMLElement;

    const dropdown = parentNode.parentElement.nextSibling.nextSibling as HTMLElement;
    openArrow.classList.toggle('open');
    parentNode.classList.toggle('open');
    dropdown.classList.toggle('open');
  });
})
//========================================================


//========================================================
//Changes html of language container
var mq = window.matchMedia( "(max-width: 900px)" );
if (mq.matches) {
    $("#svLang").html("SVENSKA");
    $("#enLang").html("ENGLISH");
}
//========================================================



//Jobbsida galleri
//========================================================
var mixPage = document.querySelector('.mixContainer');
var roleSelectDropdown = document.getElementById('field-select') as HTMLSelectElement;
var locationSelectDropdown = document.getElementById('location-select') as HTMLSelectElement;
var order = 1;


//fixar url för enskild sida
var str = window.location.search;
var splitStr = str.split("&");
var urlId = 0;
for (var i = 0; i < splitStr.length; i++) {
    if (splitStr[i].indexOf("s=") > -1) {
        urlId = parseInt(splitStr[i].replace("s=", ""));
    }
}

if(urlId == 0){
  const jobId = document.getElementById('job-id');

  if(jobId){
    urlId = parseInt(jobId.textContent);
  }
}


urlId = Number(urlId);

if(mixPage != null){
  var mixer = mixitup(mixPage, {
    animation: {
      duration: 0,
  },
  multifilter: {
      enable: true
  },
  behavior: {
      liveSort: true,
  }
  });

  roleSelectDropdown.addEventListener('change', function () {
    var jobField = roleSelectDropdown.value;
    mixer.filter(jobField);
});

locationSelectDropdown.addEventListener('change', function () {
    var jobLocation = locationSelectDropdown.value;
    mixer.filter(jobLocation);
});
}

var location = "";
var allLocations: any[] = [];
var role = "";
var allRoles: any[] = [];

function GetAllJobs(){
  $.getJSON('https://api.workbuster.com/jobs/feed/stella/5715?format=json&expirecache=1', function(result: any) {

    var ul = document.getElementById('available-jobs');
    var storedJobs = result.jobs; //lista med alla jobbobjekt
    
    const sortedJobArray = storedJobs.sort((a, b) => Number(new Date(b.published_updated_timestamp).valueOf()) - Number(new Date(a.published_updated_timestamp).valueOf()));

  

    $.each(sortedJobArray, function (i, field) {

      //skapar li tag
      var li = document.createElement('li');
      li.setAttribute('id', field.id);
      li.classList.add('mix', 'job-list-item');

      //objektinformation
      var jobImage = field.company.logo != null ? field.company.logo : null; //kolla upp detta
      var jobTitle = field.title;
      var jobLocation = field.location.name;
      var jobHybrid = field.workplace_type == "Hybrid" ? field.workplace_type : null;
      var jobRole = field.department.name;
      var jobDescripton = field.description_short;


      //Alla typer av roller
      if (jobRole != undefined && jobRole.length != 0 && jobRole != "") {
        
        if(jobRole != ""){
          li.classList.add(jobRole.toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-").replaceAll(/\s/g, "-"));
        }
        
        if (allRoles.length == 0) {
            allRoles.push(jobRole);
        }
        else {
            if (allRoles.indexOf(jobRole) == -1) {
                allRoles.push(jobRole);
                allRoles.sort();
            }
        }
    }
   
  //Alla orter
    if(jobLocation != undefined && jobLocation.length != 0 && jobLocation != ""){
      if(jobLocation != ""){
        li.classList.add(jobLocation.toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-").replaceAll(/\s/g, "-"));
      }

      if (allLocations.length == 0) {
        allLocations.push(jobLocation);
    }
    else {
        if (allLocations.indexOf(jobLocation) == -1) {
            allLocations.push(jobLocation);
            allLocations.sort();
        }
    }
    }

    //Ger en data-order
    li.setAttribute('data-order', order.toString());
    
    //skapa upp innehållet för varje jobbobjekt
    if(document.getElementsByClassName("job-section").length > 0){
      li.innerHTML = "<a class='job-list-item-link' href='/lediga-jobb/ledigt-jobb/"+ field.slug +"/"+ field.id +"';><div class='image-container'><img class='job-image' src='"+ jobImage +"'></div><div class='info-container'><p class='body bold'>"+ jobTitle +"</p><div class='location-role-container'><p class='role body-small bold'>"+ jobRole +"</p><p class='location body-small bold'>"+ jobLocation +"</p></div><p class='info-text body-small'>"+ jobDescripton +"</p><span class='job-link body'>Läs mer om tjänsten</span></div></a>";
    ul.appendChild(li);
    }

    //kollar så jobbobjekt finns
    if (li != null && ul != null) {
      var referenceElement = mixer.getState().show[1];
      order++;
      mixer.insertBefore(li, referenceElement);

      mixer.sort('order:asc');
    }

    //console.log(field.id)

    //enskild sida
    if(document.getElementsByClassName("job-item-section").length > 0){

      if(field.id == urlId && field.title != null && field.title.length > 0){


        if(field.image != ""){
          var jobPicture = document.getElementById('job-hero-picture');
          var image = document.createElement('img');
          image.classList.add('hero-image-tag');
          jobPicture.appendChild(image);

          image.src = field.image;
          //document.getElementById('job-hero-image').src = field.image;
        }

        document.getElementById('breadcrumb-page').innerHTML = field.title;
        document.getElementById('job-name').innerHTML = field.title;

        if(jobLocation != ""){
          document.getElementById('job-location').innerHTML = `Plats: ${jobLocation} ${jobHybrid != null ? "/ " + jobHybrid : ""}`;
        }
        //else {
        //  document.getElementById('job-location').innerHTML = "Plats: Ej satt";
        //}

        console.log(jobHybrid);

        //if(field.last_application_date != null){
        //  document.getElementById('job-date').innerHTML = "Sista ansökningsdag: " + field.last_application_date +"";
        //} else{
        //  document.getElementById('job-date').remove();
        //}
        

        document.title = field.title + " - Stella";
        
        GetRelatedJobs(storedJobs, jobRole, field.id);
        

        var jobItemPage = document.getElementById('job-item-page');


        var newScript = document.createElement("script");
        newScript.src = "https://stella.workbuster.com/embed?container=workbuster_container&jobid="+ field.id +"";
        jobItemPage.appendChild(newScript);

          if(jobDescripton != null){
            document.getElementById('job-item-logo').src = jobImage;
          }

          if(field.description_short != "" || field.description_short != null){
            document.getElementById('job-item-ingress').innerHTML = field.description_short;
          }
      
          if(field.description != null || field.description == ""){
            document.getElementById('job-item-text').innerHTML = field.description;
          }

          if(field.responsible.name != "" || field.responsible.name != null){

            if(field.responsible.picture_url != ''){
              var contactCard = document.getElementById('job-item-contact-image');
              var image = document.createElement('img');
              image.classList.add('image-container');
              image.setAttribute('src', field.responsible.picture_url);
              contactCard.appendChild(image);
            }

            document.getElementById('job-item-person').innerHTML = field.responsible.name;
            const jobPersonLink = document.getElementById('job-item-person-link');
            jobPersonLink.href = "mailto:" + field.responsible.email;
            jobPersonLink.innerHTML = field.responsible.email;
          }

          
        }
    }
      });


    //trycker in alla roller i field-select dropdown
    for (var i : number = 0; i < allRoles.length; i++) {
      var option = document.createElement('option');
      option.setAttribute('data-filter', '.' + allRoles[i].toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-"));
      option.setAttribute('data-mixitup-control', '');
      option.text = allRoles[i];
      option.value = '.' + allRoles[i].toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-");

      if (roleSelectDropdown != null) {
          roleSelectDropdown.appendChild(option);
      }
  }

  //trycker in alla orter i location-select dropdown
  for (var i : number = 0; i < allLocations.length; i++) {
    var option = document.createElement('option');
    option.setAttribute('data-filter', '.' + allLocations[i].toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-"));
    option.setAttribute('data-mixitup-control', '');
    option.text = allLocations[i];
    option.value = '.' + allLocations[i].toLowerCase().replace(/ä/g, 'a').replace(/å/g, 'a').replace(/ö/g, 'o').replace("/", "-");

    if (locationSelectDropdown != null) {
      locationSelectDropdown.appendChild(option);
    }
}
  })
}

//kör funktion om användare är på jobbsida
if(document.getElementsByClassName("job-section").length > 0 || document.getElementsByClassName("job-item-section").length > 0 ){
  GetAllJobs(); 
}
//========================================================



function GetRelatedJobs(jobList, role, id) {

    var relatedJobsContainer = document.getElementById('related-jobs-container');
    var ul = document.getElementById('related-job-list');
    var relatedJobs : any = [];
    //var relatedJobs = jobList.filter(jobList.title => jobList.title == field);
    


    $.each(jobList, function(i, jobItem) {
      
       if(jobItem.department.name == role && jobItem.id != id){
         relatedJobs.push(jobItem);
       }
    })

   
    if(relatedJobs.length == 0){
      relatedJobsContainer.style.display = "none";
    }

    if(relatedJobs.length != 0){
      var shuffelRelatedJobs = relatedJobs.sort(() => (0.5 - Math.random()));
    var slicedList = shuffelRelatedJobs.slice(0, 4);

    slicedList.forEach(jobListItem => {


      var li = document.createElement('li');
      li.setAttribute('id', jobListItem.id);
      li.classList.add('job-list-item');

      if(document.getElementsByClassName("job-item-section").length > 0){
        li.innerHTML = "<a class='job-list-item-link' href='/lediga-jobb/ledigt-jobb/?"+ jobListItem.slug +"&s="+ jobListItem.id +"';><div class='image-container'><img class='job-image' src='"+ jobListItem.company.logo +"'></div><div class='info-container'><p class='body bold'>"+ jobListItem.title +"</p><div class='location-role-container'><p class='role body-small bold'>"+ jobListItem.department.name +"</p><p class='location body-small bold'>"+ jobListItem.location.name +"</p></div><p class='info-text body-small'>"+ jobListItem.description_short +"</p><span class='job-link body'>Läs mer om tjänsten</span></div></a>";
      ul.appendChild(li);

      }
    });
    }
    
}